import { ca } from '@cian/analytics';

export function trackOpenNewbuildingDescription() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'Click',
    label: 'read_more_about_builder',
    useLastProducts: true,
  });
}
